<div class="footer">
  <div class="footer-content">
    <div class="footer-container">
      <div class="footer-logo">
        <img src="assets/images/aifc-logo.png" alt="AIFC" />
      </div>

      <div class="footer-grid">
        <div class="footer-section">
          <div class="footer-header">
            <div class="footer-icon">
              <img src="assets/icons/aifc/fiContacts.svg" alt="" class="section-icon" />
            </div>
            <h3 class="footer-heading">{{ "CONTACT US" | translate }}</h3>
          </div>
          <p class="footer-text">+7 (7172) 959 000</p>
          <a class="footer-text" href="mailto:client@aifc.kz">client&#64;aifc.kz</a>
        </div>

        <div class="footer-section">
          <div class="footer-header">
            <div class="footer-icon">
              <img src="assets/icons/aifc/fiGeo.svg" alt="" class="section-icon" />
            </div>
            <h3 class="footer-heading">{{ "Location" | translate }}</h3>
          </div>
          <p class="footer-text">
            {{ "Mangilik El, bldg 55/18 C3.3" | translate }},
            {{ "Astana city," | translate }}
            {{ "The Republic of Kazakhstan" | translate }}
          </p>
        </div>

        <div class="footer-section">
          <div class="footer-header">
            <div class="footer-icon">
              <img src="assets/icons/aifc/fiClock.svg" alt="" class="section-icon" />
            </div>
            <h3 class="footer-heading">{{ "OFFICE HOURS" | translate }}</h3>
          </div>
          <p class="footer-text">{{ "10am - 6pm" | translate }}</p>
          <p class="footer-text">{{ "Monday / Friday" | translate }}</p>
        </div>

        <div class="footer-section social-section">
          <div class="footer-header">
            <div class="footer-icon">
              <img src="assets/icons/aifc/fiFollow.svg" alt="" class="section-icon" />
            </div>
            <h3 class="footer-heading">{{ "FOLLOW US" | translate }}</h3>
          </div>
          <div class="social-icons">
            <a
              href="https://www.instagram.com/aifckz/"
              class="social-icon"
              target="_blank"
              rel="noopener"
              aria-label="Instagram"
            >
              <img src="assets/icons/aifc/fiInsta.svg" alt="Instagram" />
            </a>
            <a
              href="https://t.me/aifc_official"
              class="social-icon"
              target="_blank"
              rel="noopener"
              aria-label="Telegram"
            >
              <img src="assets/icons/aifc/fiTg.svg" alt="Telegram" />
            </a>
            <a
              href="https://www.linkedin.com/company/aifckz/"
              class="social-icon"
              target="_blank"
              rel="noopener"
              aria-label="LinkedIn"
            >
              <img src="assets/icons/aifc/fiLinkedin.svg" alt="LinkedIn" />
            </a>
            <a
              href="https://www.youtube.com/@aifckz"
              class="social-icon"
              target="_blank"
              rel="noopener"
              aria-label="YouTube"
            >
              <img src="assets/icons/aifc/fiYt.svg" alt="YouTube" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <hr class="footer-divider" />

  <div class="footer-bottom">
    <div class="footer-container">
      <div class="footer-bottom-content">
        <div class="footer-links">
          <a
            href="https://digitalresident.kz/documentation/Digital_Resident_Portal_Terms_and_Conditions.pdf"
            class="footer-link"
            target="_blank"
            rel="noopener"
          >
            {{ "Privacy policy" | translate }}
          </a>
        </div>
        <div class="footer-copyright">
          {{ currentYear | date: "yyyy" }} © {{ "AIFC All rights reserved" | translate }}
        </div>
        <div class="footer-languages">
          <a
            *ngFor="let lang of languages"
            href="#"
            class="lang-link"
            [class.active]="isActiveLang(lang)"
            (click)="setLang(lang, $event)"
          >
            {{ lang.name }}
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
